import React from 'react';
import { HandleUserSelection } from 'containers/HandlesPanel/types';
import { useTranslation } from 'react-i18next';
import useMedia from 'use-media';
import GenericObjectSelector from 'components/GenericObjectSelector';

// import styled from 'styled-components/macro';

interface Props {
  handlePositionSelected: HandleUserSelection[];
  selection: any;
  handleSelection: any;
  doors: boolean;
  drawers: boolean;
  slats: boolean;
}

const SelectionTypeHandlesContentPanel = ({
  handlePositionSelected,
  selection,
  handleSelection,
  doors,
  drawers,
  slats,
}: Props) => {
  const { t } = useTranslation();
  const isMobile = useMedia({ maxWidth: 1023 });

  return (
    <>
      <div className="flex flex-col justify-center py-1">
        {doors && (
          <div className="my-1">
            <GenericObjectSelector
              title={t('All doorcaps and buttons')}
              selected={handlePositionSelected.includes('Doors') && !isMobile}
              onClick={(e: any) => selection(e, 'Doors', false)}
              present={true}
              canAddNew
            />
          </div>
        )}
        {slats && (
          <div className="my-1">
            <GenericObjectSelector
              title={t('All wardrobe slats')}
              selected={handlePositionSelected.includes('Slats') && !isMobile}
              onClick={(e: any) => selection(e, 'Slats', false)}
              present={true}
              canAddNew
            />
          </div>
        )}
        {drawers && (
          <div className="my-1">
            <GenericObjectSelector
              title={t("All drawers' handles and buttons")}
              selected={handlePositionSelected.includes('Drawers') && !isMobile}
              onClick={(e: any) => selection(e, 'Drawers', false)}
              present={true}
              canAddNew
            />
          </div>
        )}
      </div>
    </>
  );
};

export default SelectionTypeHandlesContentPanel;
